import { gql } from "@apollo/client";

export const UPDATE_LIVE_URL = gql`
mutation UpdateLiveUrl($racetrack_id:String!,$url:String!){
    updateLiveUrl(racetrack_id:$racetrack_id, url:$url){
      id
      url_live
    }
}
`;